module.exports = __webpack_public_path__ + "static/media/Mortgage.105098b4.svg";